import { EDIT_PROFILE_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import updateProfile from 'root/src/client/logic/profile/thunks/updateProfile'
import updateProfileOnSuccess from 'root/src/client/logic/project/thunks/updateProfileOnSuccess'

export default {
	[EDIT_PROFILE_FORM_MODULE_ID]: [
		{
			action: updateProfile,
			onSuccess: updateProfileOnSuccess,
		},
	],
}
